import React from "react";
import "./StepperControl.css";

interface StepperControlProps {
  id: string;
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  required?: boolean;
}

export const StepperControl: React.FC<StepperControlProps> = ({
  id,
  label,
  value,
  onChange,
  min = 0,
  max,
  required = false,
}) => {
  const handleDecrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleIncrement = () => {
    if (max === undefined || value < max) {
      onChange(value + 1);
    }
  };

  return (
    <div className="stepper-control">
      <label htmlFor={id} className="input-label mb-1.5">
        {label}
        {required && <span className="required-indicator" aria-label="required">*</span>}
      </label>
      <div className="stepper-wrapper">
        <button
          type="button"
          onClick={handleDecrement}
          disabled={value <= min}
          className="stepper-button stepper-button-decrement"
          aria-label={`Decrease ${label}`}
        >
          −
        </button>
        <input
          type="number"
          id={id}
          value={value}
          readOnly
          className="stepper-value"
          aria-label={`${label} count`}
          required={required}
        />
        <button
          type="button"
          onClick={handleIncrement}
          disabled={max !== undefined && value >= max}
          className="stepper-button stepper-button-increment"
          aria-label={`Increase ${label}`}
        >
          +
        </button>
      </div>
    </div>
  );
};

